import { render } from "./SuccessToaster.vue?vue&type=template&id=23fb24bb"
import script from "./SuccessToaster.vue?vue&type=script&lang=js"
export * from "./SuccessToaster.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__